export default __webpack_public_path__ + "static/media/ResendVerification.64f26bed.png";